import { createSlice } from "@reduxjs/toolkit";
import { OUTER } from "../../consts/layers";
import { DEFAULT_FIT_BOUNDS } from "../../consts/map";
import {
  setZoomValue,
  calculateZoomLevel,
  setTargetZoomLevel,
  setReceivedUserInput,
  setFitBounds,
  setJumpTo,
} from "./thunkActions";

const initialState = {
  fitBounds: DEFAULT_FIT_BOUNDS,
  fitBoundsOptions: null,
  zoom: [14],
  zoomLevel: OUTER,
  targetZoomLevel: null,
  receivedUserInput: null,
  visiblePostcodes: [],
  centerPoint: null,
  isZooming: false,
  streetView: false,
  popupDetails: null,
  lastPopupDetails: null,
  artificialFeatures: null,
  jumpTo: null,
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    resetMapState: () => initialState,
    setVisiblePostcodes: (state, action) => {
      state.visiblePostcodes = action.payload.postcodes;
    },
    setCenterPoint: (state, action) => {
      state.centerPoint = action.payload;
    },
    setIsZooming: (state, action) => {
      state.isZooming = action.payload;
    },
    setStreetView: (state, action) => {
      state.streetView = action.payload;
    },
    setPopupDetails: (state, action) => {
      state.popupDetails = action.payload;
      if (!action.payload) return;
      state.lastPopupDetails = action.payload;
    },
    setArtificialFeatures: (state, action) => {
      state.artificialFeatures = action.payload;
    },
    resetArtificialFeatures: (state, action) => {
      state.artificialFeatures = Object.keys(action.payload).reduce(
        (acc, level) => {
          Object.keys(action.payload[level]).forEach((key) => {
            acc[key] = {};
          });
          return acc;
        },
        {}
      );
    },
    resetJumpTo: (state) => {
      state.jumpTo = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setFitBounds.fulfilled, (state, action) => {
        const { bbox, targetZoomLevel, fitBoundsOptions } = action.payload;
        let newFitBounds = initialState.fitBounds;
        if (bbox.length === 4) {
          newFitBounds = [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[3]],
          ];
        } else {
          newFitBounds = bbox;
        }
        state.fitBounds = newFitBounds;
        state.fitBoundsOptions = fitBoundsOptions;
        state.targetZoomLevel = targetZoomLevel;
      })
      .addCase(setJumpTo.fulfilled, (state, action) => {
        const { center, zoom, targetZoomLevel } = action.payload;
        state.jumpTo = {
          center,
          zoom,
        };
        state.targetZoomLevel = targetZoomLevel;
      })
      .addCase(setReceivedUserInput.fulfilled, (state, action) => {
        state.receivedUserInput = action.payload;
      })
      .addCase(setTargetZoomLevel.fulfilled, (state, action) => {
        state.targetZoomLevel = action.payload;
      })
      .addCase(setZoomValue.fulfilled, (state, action) => {
        state.zoom = action.payload;
      })
      .addCase(calculateZoomLevel.fulfilled, (state, action) => {
        state.zoomLevel = action.payload;
      });
  },
});

const { actions, reducer } = mapSlice;
const {
  setVisiblePostcodes,
  setCenterPoint,
  resetMapState,
  setIsZooming,
  setStreetView,
  setPopupDetails,
  setArtificialFeatures,
  resetArtificialFeatures,
  resetJumpTo,
} = actions;
export {
  reducer,
  setVisiblePostcodes,
  setCenterPoint,
  resetMapState,
  setIsZooming,
  setStreetView,
  setPopupDetails,
  setArtificialFeatures,
  resetArtificialFeatures,
  resetJumpTo,
};
